export default __webpack_public_path__ + "static/media/video_preview_1.c7a59c34.png";